import styled, { css } from 'styled-components';
import { Image as BoltImage } from '@sainsburys-tech/bolt';
export var Heading = styled.div.withConfig({
  displayName: "ImageAndTablestyles__Heading",
  componentId: "vzacxf-0"
})(["margin-top:30px;margin-bottom:15px;"]);
export var Image = styled(BoltImage).withConfig({
  displayName: "ImageAndTablestyles__Image",
  componentId: "vzacxf-1"
})(["object-fit:contain;width:100%;margin:20px auto;max-width:430px;max-height:220px;", ""], function (props) {
  return css(["@media screen and (max-width:", "){margin-top:0px;max-height:170px;}"], props.theme.size.breakpoint['max-width'].xs);
});
export var TableRow = styled.tr.withConfig({
  displayName: "ImageAndTablestyles__TableRow",
  componentId: "vzacxf-2"
})(["background:", ";&:nth-child(even){background:", ";}td:nth-child(1){width:10%;}td:nth-child(2){width:45%;}td:nth-child(3){width:45%;}"], function (props) {
  return props.theme.color.monochrome.white;
}, function (props) {
  return props.theme.color.monochrome.lighter;
});
export var FlexWrapper = styled.div.withConfig({
  displayName: "ImageAndTablestyles__FlexWrapper",
  componentId: "vzacxf-3"
})(["display:flex;", ""], function (props) {
  return css(["@media screen and (max-width:", "){flex-direction:column;}"], props.theme.size.breakpoint['max-width'].xs);
});
export var ImageContainer = styled.div.withConfig({
  displayName: "ImageAndTablestyles__ImageContainer",
  componentId: "vzacxf-4"
})(["width:50%;", ""], function (props) {
  return css(["@media screen and (max-width:", "){width:100%;}"], props.theme.size.breakpoint['max-width'].xs);
});
export var TableContainer = styled.div.withConfig({
  displayName: "ImageAndTablestyles__TableContainer",
  componentId: "vzacxf-5"
})(["width:50%;padding-left:15px;", ""], function (props) {
  return css(["@media screen and (max-width:", "){width:100%;padding:0px;}"], props.theme.size.breakpoint['max-width'].xs);
});
var sharedCellStyles = css(["padding:10px 15px;border:none;vertical-align:middle;"]);
export var TableHeader = styled.th.withConfig({
  displayName: "ImageAndTablestyles__TableHeader",
  componentId: "vzacxf-6"
})(["&&{", ";font-weight:", ";}"], sharedCellStyles, function (props) {
  return props.theme.font.weight.bold;
});
export var TableHeaderCentre = styled.th.withConfig({
  displayName: "ImageAndTablestyles__TableHeaderCentre",
  componentId: "vzacxf-7"
})(["&&{", ";text-align:center;font-weight:", ";}"], sharedCellStyles, function (props) {
  return props.theme.font.weight.bold;
});
export var LetterWrapper = styled.td.withConfig({
  displayName: "ImageAndTablestyles__LetterWrapper",
  componentId: "vzacxf-8"
})(["&&{", ";text-align:center;font-weight:", ";}"], sharedCellStyles, function (props) {
  return props.theme.font.weight.bold;
});
export var PropertyWrapper = styled.td.withConfig({
  displayName: "ImageAndTablestyles__PropertyWrapper",
  componentId: "vzacxf-9"
})(["&&{", ";}"], sharedCellStyles);
export var SizeWrapper = styled.td.withConfig({
  displayName: "ImageAndTablestyles__SizeWrapper",
  componentId: "vzacxf-10"
})(["&&{", ";text-align:center;}"], sharedCellStyles);